import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import CreditUsageReportTabPageComponent from './CreditUsageReportTabPage';
import { selectSessionRole } from '../../../store/selectors/session';

export const CreditUsageReportTabPage = connect(
    () => {

        return (state, props) => ({
            userRole:selectSessionRole(state as never)
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            
        }, dispatch)
    })
)(injectIntl(CreditUsageReportTabPageComponent));